var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#15F4CB}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h150v150H0V0z",
    fill: "none",
    id: "Layer_2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logosandtypes_com"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.6 132.7v-5.9c0-.3.1-.4.3-.6 3.5-3.5 41.6-41.7 41.8-41.8.2-.2.4-.3.6-.3h5.9c.5 0 .8.5.8.8V131c0 1.6-1.4 2.5-2.5 2.5H78.4c-.5 0-.8-.4-.8-.8zM71.4 18.3H30.6c-1.1 0-2 .9-2 2v111.1c0 1.1.9 2 2 2h40.7c1.1 0 2-.9 2-2V20.3c.1-1.1-.8-2-1.9-2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5951061c72842c72ac5fb949b1717fdc.svg";
export { ForwardRef as ReactComponent };